import { Tag } from '@cian/components';
import * as React from 'react';

import { INewbuildingCompletionAfterTag } from '../../../state/tags/definitions/newbuilding_completion_after';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IBuildingDoneTagItemProps {
  tag: INewbuildingCompletionAfterTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const BuildingDoneTagItem = ({ tag, onDeleteClick, withNewTag }: IBuildingDoneTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      Год сдачи: позднее {tag.value}
    </TagComponent>
  );
};
